import axios from 'axios'
import store from '../store/index'
import router from "@/router";
import {UserAgentApplication} from 'msal'

const financeiro = axios.create({
    baseURL: process.env.VUE_APP_FINANCEIRO_URL
});

financeiro.interceptors.request.use(async request => {
    request.baseURL = process.env.VUE_APP_FINANCEIRO_URL
    request.headers['Authorization'] = 'Bearer ' + localStorage.getItem('tokenApi')
    request.headers['api-token'] = process.env.VUE_API_TOKEN_BF
    var deveTerLoading = !request.url.split('&').includes('loading=false');

    if (deveTerLoading) {
        store.commit('spinner/toggleSpinner', true)
    }
    return request
})

financeiro.interceptors.response.use(response => {
    store.commit('spinner/toggleSpinner', false)
    return response;
}, error => {
    store.commit('spinner/toggleSpinner', false)

    if (error.response.status && ([403, 500, 401].includes(error.response.status))) {
        router.push({name: 'error', query: {error: error.response.status}})
    }

    console.log('error', error);

    return Promise.reject(error)
})

export default financeiro;



// WEBPACK FOOTER //
// ./src/plugins/FinanceiroInterceptor.js